import { gql } from '@apollo/client';

export const LOCALES_QUERY = gql`
    query locales {
        locales {
            totalCount
            edges {
                node {
                    code
                    label
                    labelEnUs
                    cmxSupported
                }
            }
        }
    }
`;